exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-folder[data-v-22b6f9d9]{font-size:3em;cursor:pointer;color:#c3040d}.dropin .fa-folder[data-v-22b6f9d9]{font-size:3.5em;color:#ffb700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22b6f9d9","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/FolderElement.vue
// module id = FegH
// module chunks = 0